export default function(data) {
var __t, __p = '';
__p += '<form action=\'' +
((__t = ( App.Routes.request_reset_user_passwords_path() )) == null ? '' : __t) +
'\' method=\'POST\' class=\'password-reset replace-on-ajax-success\' data-type=\'json\' data-remote=\'true\'>\n  <label for=\'email\'>\n  <span class="default">Enter your email:</span>\n  <span class="error"></span>\n  </label>\n  <input type=\'email\' id=\'email\' name=\'email\' placeholder=\'Email Address\' required />\n  <input type=\'submit\' class=\'rounded-button\' value=\'Send Email\' />\n</form>\n';
return __p
}